module.exports = __webpack_public_path__ + "static/slider2-935e4164478a9f7062700a2fe6172954.jpg";